
const KEYS = {
  GOOGLE_CLIENT_ID: process.env.GATSBY_GOOGLE_CLIENT_ID,
  FACEBOOK_APP_ID: process.env.GATSBY_FACEBOOK_APP_ID,
};

export default KEYS;
